import { createLink, navigateToCallback } from '../components';
export function useHeaderState(navigationContext, navigate, location, basename, headerItems, headerPrimaryItem) {
    return {
        headerItems: headerItems ? headerItems.map((item) => mapHeaderItem(item, navigationContext, navigate, basename)) : undefined,
        headerPrimaryItem: headerPrimaryItem ? mapHeaderItem(headerPrimaryItem, navigationContext, navigate, basename) : undefined,
    };
}
function mapHeaderItem(item, navigationContext, navigate, basename) {
    var _a;
    const { navigateTo, onClick } = item;
    return {
        icon: item.icon,
        label: item.label,
        href: (_a = item.href) !== null && _a !== void 0 ? _a : (item.navigateTo ? createLink([basename !== null && basename !== void 0 ? basename : '/', item.navigateTo]) : undefined),
        onClick: navigateToCallback(navigationContext, navigate, navigateTo, onClick),
        menuItems: item.menuItems
            ? item.menuItems.map((menuItem) => {
                var _a;
                const { navigateTo, onClick } = menuItem;
                return {
                    label: menuItem.label,
                    onClick: (_a = navigateToCallback(navigationContext, navigate, navigateTo, onClick)) !== null && _a !== void 0 ? _a : (() => undefined),
                    disabled: menuItem.disabled,
                    ['data-test']: menuItem['data-test'],
                    ['aria-label']: menuItem['aria-label'],
                };
            })
            : undefined,
        ['data-test']: item['data-test'],
    };
}
